import E3Widget from '@src/modules/performance/components/dashboard-widgets/E3Widget';
import DeliveryWidget from '@src/modules/performance/components/dashboard-widgets/DeliveryWidget';
import DeliveryPerformanceWidget from '@src/modules/performance/components/dashboard-widgets/DeliveryPerformanceWidget';
import AmenityWidget from '@src/modules/performance/components/dashboard-widgets/AmenityWidget';
import SafetyWidget from '@src/modules/performance/components/dashboard-widgets/SafetyWidget';
import NetworkPhysicalCharacteristicsWidget from '@src/modules/performance/components/dashboard-widgets/NetworkPhysicalCharacteristicsWidget';
import RoadNetworkUseWidget from '@src/modules/performance/components/dashboard-widgets/RoadNetworkUseWidget';
import NetworkAvailabilityAccessibilityWidget from '@src/modules/performance/components/dashboard-widgets/NetworkAvailabilityAccessibilityWidget';
import PublicTransportWidget from '@src/modules/performance/components/dashboard-widgets/PublicTransportWidget';
import TerritorialActivityWidget from '@src/modules/performance/components/dashboard-widgets/TerritorialActivityWidget';
import ServicePerformanceWidget from '@src/modules/performance/components/dashboard-widgets/ServicePerformanceWidget';
import CoinvestorAssuranceWidget from '@src/modules/performance/components/dashboard-widgets/CoinvestorAssuranceWidget';
import TemporaryTrafficManagementWidget from '@src/modules/performance/components/dashboard-widgets/TemporaryTrafficManagementWidget';
import ActivityManagementWidget from '@src/modules/performance/components/dashboard-widgets/ActivityManagementWidget';
import ActivityManagementPlanning from '../views/reports/components/report-sections/ActivityManagementPlanning';
import ActivityManagementProcurement from '../views/reports/components/report-sections/ActivityManagementProcurement';
import RoadConditionSealedRoads from '../views/reports/components/report-sections/RoadConditionSealedRoads';
import ServicePerformanceAnnualTargets from '../views/reports/components/report-sections/ServicePerformanceAnnualTargets';
import RoadMaintenanceDeliveryActivitiesDrainage from '../views/reports/components/report-sections/RoadMaintenanceDeliveryActivitiesDrainage';
import RoadMaintenanceDeliveryActivitiesRoads from '../views/reports/components/report-sections/RoadMaintenanceDeliveryActivitiesRoads';
import RoadMaintenanceDeliveryCosts from '../views/reports/components/report-sections/RoadMaintenanceDeliveryCosts';
import RoadMaintenanceDeliveryOtherWorks from '../views/reports/components/report-sections/RoadMaintenanceDeliveryOtherWorks';
import TransportProgrammeDeliveryActivityClassExpenditure from '../views/reports/components/report-sections/TransportProgrammeDeliveryActivityClassExpenditure';
import TransportProgrammeDeliveryCostEfficiencyTotalExpenditure from '../views/reports/components/report-sections/TransportProgrammeDeliveryCostEfficiencyTotalExpenditure';
import TransportProgrammeDeliveryFunding from '../views/reports/components/report-sections/TransportProgrammeDeliveryFunding';
import TransportProgrammeDeliveryValuation from '../views/reports/components/report-sections/TransportProgrammeDeliveryValuation';
import RoadSafetyByMode from '../views/reports/components/report-sections/RoadSafetyByMode';
import RoadSafetyCrashDistributionStreetCategories from '../views/reports/components/report-sections/RoadSafetyCrashDistributionStreetCategories';
import RoadSafetyNetwork from '../views/reports/components/report-sections/RoadSafetyNetwork';
import CoInvestorAssuranceAudit from '../views/reports/components/report-sections/CoInvestorAssuranceAudit';
import E3Cost from '../views/reports/components/report-sections/E3Cost';
import E3PeerGroup from '../views/reports/components/report-sections/E3PeerGroup';
import E3Quality from '../views/reports/components/report-sections/E3Quality';
import E3Quantity from '../views/reports/components/report-sections/E3Quantity';
import NetworkPhysicalCharacteristicsBridges from '../views/reports/components/report-sections/NetworkPhysicalCharacteristicsBridges';
import NetworkPhysicalCharacteristicsCycleways from '../views/reports/components/report-sections/NetworkPhysicalCharacteristicsCycleways';
import NetworkPhysicalCharacteristicsRoads from '../views/reports/components/report-sections/NetworkPhysicalCharacteristicsRoads';
import RoadNetworkUseJourneyDistributionStreetCategory from '../views/reports/components/report-sections/RoadNetworkUseJourneyDistributionStreetCategory';
import NetworkAvailabilityFreightAccessibilityDistributionOnrc from '../views/reports/components/report-sections/NetworkAvailabilityFreightAccessibilityDistributionOnrc';
import NetworkAvailabilityResilienceDistributionsStreetCategory from '../views/reports/components/report-sections/NetworkAvailabilityResilienceDistributionsStreetCategory';
import TerritorialActivityEconomic from '../views/reports/components/report-sections/TerritorialActivityEconomic';
import TerritorialActivityPopulation from '../views/reports/components/report-sections/TerritorialActivityPopulation';
import TemporaryTrafficManagementCostConfidence from '../views/reports/components/report-sections/TemporaryTrafficManagementCostConfidence';
import TemporaryTrafficManagementCostPercentage from '../views/reports/components/report-sections/TemporaryTrafficManagementCostPercentage';
import RoadConditionAmenitySealedRoads from '../views/reports/components/report-sections/RoadConditionAmenitySealedRoads';
import RoadConditionRoadRoughness from '../views/reports/components/report-sections/RoadConditionRoadRoughness';
import RoadMaintenanceDeliveryQuarterlyCosts from '../views/reports/components/report-sections/RoadMaintenanceDeliveryQuarterlyCosts';
import PublicTransportUse from '../views/reports/components/report-sections/PublicTransportUse';
import PublicTransportFleetSize from '../views/reports/components/report-sections/PublicTransportFleetSize';
import PublicTransportCommunityServiced from '../views/reports/components/report-sections/PublicTransportCommunityServiced';
import PublicTransportCommunities from '../views/reports/components/report-sections/PublicTransportCommunities';
import PublicTransportExpenditure from '../views/reports/components/report-sections/PublicTransportExpenditure';
import PublicTransportTotalMobilityUse from '../views/reports/components/report-sections/PublicTransportTotalMobilityUse';
import PublicTransportTotalMobilityCommunities from '../views/reports/components/report-sections/PublicTransportTotalMobilityCommunities';
import PotholeRepairsWidget from '../components/dashboard-widgets/PotholeRepairsWidget';
import TransportProgrammeDeliveryRoadSafety from '../views/reports/components/report-sections/TransportProgrammeDeliveryRoadSafety';
import TransportProgrammeDeliveryWalkingCycling from '../views/reports/components/report-sections/TransportProgrammeDeliveryWalkingCycling';
import TransportProgrammeDeliveryManagement from '../views/reports/components/report-sections/TransportProgrammeDeliveryManagement';
import DataQualityWidget from '../components/dashboard-widgets/DataQualityWidget';
import DataQualityScore from '../views/reports/components/report-sections/DataQualityScore';
import DataQualityExpectedStandard from '../views/reports/components/report-sections/DataQualityExpectedStandard';
import RoadNetworkUseRoadUse from '../views/reports/components/report-sections/RoadNetworkUseRoadUse';
import RoadNetworkUseRestrictedBridges from '../views/reports/components/report-sections/RoadNetworkUseRestrictedBridges';
import RoadMaintenanceDeliveryPavementResurfacing from '../views/reports/components/report-sections/RoadMaintenanceDeliveryPavementResurfacing';
import RoadSafetyDsi from '../views/reports/components/report-sections/RoadSafetyDsi';
import RoadSafetyCrashDistributionFreight from '../views/reports/components/report-sections/RoadSafetyCrashDistributionFreight';
import RoadSafetyCrashDistributionGeneralTraffic from '../views/reports/components/report-sections/RoadSafetyCrashDistributionGeneralTraffic';
import TransportProgrammeDeliveryCostEfficiencyMaintenance from '../views/reports/components/report-sections/TransportProgrammeDeliveryCostEfficiencyMaintenance';
import RoadNetworkUseJourneyDistributionOnrc from '../views/reports/components/report-sections/RoadNetworkUseJourneyDistributionOnrc';
import RoadNetworkUseJourneyDistributionFreight from '../views/reports/components/report-sections/RoadNetworkUseJourneyDistributionFreight';
import RoadNetworkUseJourneyDistributionGeneralTraffic from '../views/reports/components/report-sections/RoadNetworkUseJourneyDistributionGeneralTraffic';
import E3Trends from '../views/reports/components/report-sections/E3Trends';
import RoadSafetyCrashConditions from '../views/reports/components/report-sections/RoadSafetyCrashConditions';
import RoadSafetyCrashFactors from '../views/reports/components/report-sections/RoadSafetyCrashFactors';
import RoadSafetyRoadAssessmentRating from '../views/reports/components/report-sections/RoadSafetyRoadAssessmentRating';
import RoadNetworkUseHeavyVehicleRoadUse from '../views/reports/components/report-sections/RoadNetworkUseHeavyVehicleRoadUse';
import RoadConditionRutting from '../views/reports/components/report-sections/RoadConditionRutting';
import RoadConditionTexture from '../views/reports/components/report-sections/RoadConditionTexture';
import NetworkAvailabilityFreightAccessibilityDistributionStreetCategory from '../views/reports/components/report-sections/NetworkAvailabilityFreightAccessibilityDistributionStreetCategory';
import NetworkAvailabilityFreightAccessibilityDistributionFreight from '../views/reports/components/report-sections/NetworkAvailabilityFreightAccessibilityDistributionFreight';
import NetworkAvailabilityFreightAccessibilityDistributionGeneralTraffic from '../views/reports/components/report-sections/NetworkAvailabilityFreightAccessibilityDistributionGeneralTraffic';
import NetworkPhysicalCharacteristicsAverageLife from '../views/reports/components/report-sections/NetworkPhysicalCharacteristicsAverageLife';
import NetworkAvailabilityResilienceDistributionsOnrc from '../views/reports/components/report-sections/NetworkAvailabilityResilienceDistributionsOnrc';
import NetworkAvailabilityResilienceDistributionsFreight from '../views/reports/components/report-sections/NetworkAvailabilityResilienceDistributionsFreight';
import NetworkAvailabilityResilienceDistributionsGeneralTraffic from '../views/reports/components/report-sections/NetworkAvailabilityResilienceDistributionsGeneralTraffic';

export const reportGroups = [
  {
    id: 1,
    name: 'Activity Management',
    reportKey: 'activityManagement',
  },
  {
    id: 2,
    name: 'Value for Money, Efficiency & Effectiveness',
    reportKey: 'efficiencyEffectivenessEconomy',
  },
  {
    id: 3,
    name: 'Transport Programme Delivery',
    reportKey: 'delivery',
  },
  {
    id: 4,
    name: 'Road Maintenance Delivery',
    reportKey: 'deliveryPerformance',
  },
  {
    id: 5,
    name: 'Road Condition',
    reportKey: 'amenityAndCondition',
  },
  {
    id: 6,
    name: 'Road Safety',
    reportKey: 'safety',
  },
  {
    id: 7,
    name: 'Network Physical Characteristics',
    reportKey: 'networkPhysicalCharacteristics',
  },
  {
    id: 8,
    name: 'Road Network Use',
    reportKey: 'roadNetworkUse',
  },
  {
    id: 9,
    name: 'Network Availability & Accessibility',
    reportKey: 'networkAvailability',
  },
  {
    id: 10,
    name: 'Public Transport',
    reportKey: 'publicTransport',
  },
  {
    id: 11,
    name: 'Territorial Activity',
    reportKey: 'territorialActivity',
  },
  {
    id: 12,
    name: 'Service Performance',
    reportKey: 'servicePerformance',
  },
  {
    id: 13,
    name: 'Co-investor Assurance',
    reportKey: 'coinvestorAssurance',
  },
  {
    id: 14,
    name: 'Temporary Traffic Management',
    reportKey: 'temporaryTrafficManagement',
  },
  {
    id: 15,
    name: 'Pothole Repairs',
    reportKey: 'potholeRepairs',
  },
  {
    id: 16,
    name: 'Data Quality',
    reportKey: 'dataQuality',
  },
];

// List of components to be available in the custom report
// Each component should have a unique id and groupId that matches the reportGroups
// Dashboard widgets are identified by type 'dashboard-widget'
// Report sections are identified by type 'report-section'

export const availableReportComponents = [
  {
    component: <ActivityManagementWidget />,
    id: 1,
    groupId: 1,
    title: 'Activity Management KPI',
    type: 'dashboard-widget',
  },
  {
    component: <E3Widget />,
    id: 2,
    groupId: 2,
    title: 'E3 KPI',
    type: 'dashboard-widget',
  },
  {
    component: <DeliveryWidget />,
    id: 3,
    groupId: 3,
    title: 'Transport Programme Delivery KPI',
    type: 'dashboard-widget',
  },
  {
    component: <DeliveryPerformanceWidget />,
    id: 4,
    groupId: 4,
    title: 'Road Maintenance Delivery KPI',
    type: 'dashboard-widget',
  },
  {
    component: <AmenityWidget />,
    id: 5,
    groupId: 5,
    title: 'Road Condition KPI',
    type: 'dashboard-widget',
  },
  {
    component: <SafetyWidget />,
    id: 6,
    groupId: 6,
    title: 'Road Safety KPI',
    type: 'dashboard-widget',
  },
  {
    component: <NetworkPhysicalCharacteristicsWidget />,
    id: 7,
    groupId: 7,
    title: 'Network Physical Characteristics KPI',
    type: 'dashboard-widget',
  },
  {
    component: <RoadNetworkUseWidget />,
    id: 8,
    groupId: 8,
    title: 'Road Network Use KPI',
    type: 'dashboard-widget',
  },
  {
    component: <NetworkAvailabilityAccessibilityWidget />,
    id: 9,
    groupId: 9,
    title: 'Network Availability & Accessibility KPI',
    type: 'dashboard-widget',
  },
  {
    component: <PublicTransportWidget />,
    id: 10,
    groupId: 10,
    title: 'Public Transport KPI',
    type: 'dashboard-widget',
  },
  {
    component: <TerritorialActivityWidget />,
    id: 11,
    groupId: 11,
    title: 'Territorial Activity KPI',
    type: 'dashboard-widget',
  },
  {
    component: <ServicePerformanceWidget />,
    id: 12,
    groupId: 12,
    title: 'Service Performance KPI',
    type: 'dashboard-widget',
  },
  {
    component: <CoinvestorAssuranceWidget />,
    id: 13,
    groupId: 13,
    title: 'Co-investor Assurance KPI',
    type: 'dashboard-widget',
  },
  {
    component: <TemporaryTrafficManagementWidget />,
    id: 14,
    groupId: 14,
    title: 'Temporary Traffic Management KPI',
    type: 'dashboard-widget',
  },
  {
    component: <PotholeRepairsWidget />,
    id: 15,
    groupId: 15,
    title: 'Pothole Repairs KPI',
    type: 'dashboard-widget',
  },
  {
    component: <ActivityManagementPlanning />,
    id: 16,
    groupId: 1,
    title: 'Planning',
    type: 'report-section',
  },
  {
    component: <ActivityManagementProcurement />,
    id: 17,
    groupId: 1,
    title: 'Procurement',
    type: 'report-section',
  },
  {
    component: <DataQualityScore />,
    id: 18,
    groupId: 16,
    title: 'Data Quality Score',
    type: 'report-section',
  },
  {
    component: <RoadConditionAmenitySealedRoads />,
    id: 19,
    groupId: 5,
    title: 'Smooth Travel Exposure',
    type: 'report-section',
  },
  {
    component: <RoadConditionSealedRoads />,
    id: 20,
    groupId: 5,
    title: 'Road Condition (Sealed Roads)',
    type: 'report-section',
  },
  {
    component: <ServicePerformanceAnnualTargets />,
    id: 21,
    groupId: 12,
    title: 'Annual Targets',
    type: 'report-section',
  },
  {
    component: <RoadMaintenanceDeliveryActivitiesDrainage />,
    id: 22,
    groupId: 4,
    title: 'Drainage Activities',
    type: 'report-section',
  },
  {
    component: <RoadMaintenanceDeliveryActivitiesRoads />,
    id: 23,
    groupId: 4,
    title: 'Road Activities',
    type: 'report-section',
  },
  {
    component: <RoadMaintenanceDeliveryCosts />,
    id: 24,
    groupId: 4,
    title: 'Delivery Costs',
    type: 'report-section',
  },
  {
    component: <RoadMaintenanceDeliveryOtherWorks />,
    id: 25,
    groupId: 4,
    title: 'Other Works',
    type: 'report-section',
  },
  {
    component: <TransportProgrammeDeliveryRoadSafety />,
    id: 26,
    groupId: 3,
    title: 'Road Safety',
    type: 'report-section',
  },
  {
    component: <TransportProgrammeDeliveryActivityClassExpenditure />,
    id: 27,
    groupId: 3,
    title: 'Activity Class Expenditure',
    type: 'report-section',
  },
  {
    component: <TransportProgrammeDeliveryCostEfficiencyTotalExpenditure />,
    id: 28,
    groupId: 3,
    title: 'Cost Efficiency - Total Expenditure',
    type: 'report-section',
  },
  {
    component: <TransportProgrammeDeliveryFunding />,
    id: 29,
    groupId: 3,
    title: 'Funding',
    type: 'report-section',
  },
  {
    component: <TransportProgrammeDeliveryValuation />,
    id: 30,
    groupId: 3,
    title: 'Valuation',
    type: 'report-section',
  },
  {
    component: <RoadSafetyByMode />,
    id: 31,
    groupId: 6,
    title: 'Vulnerable User DSIs',
    type: 'report-section',
  },
  {
    component: <RoadSafetyCrashDistributionStreetCategories />,
    id: 32,
    groupId: 6,
    title: 'DSI Distribution (ONF Street Categories)',
    type: 'report-section',
  },
  {
    component: <RoadSafetyNetwork />,
    id: 33,
    groupId: 6,
    title: 'Network DSI',
    type: 'report-section',
  },
  {
    component: <CoInvestorAssuranceAudit />,
    id: 34,
    groupId: 13,
    title: 'Audit and Assurance',
    type: 'report-section',
  },
  {
    component: <E3Cost />,
    id: 35,
    groupId: 2,
    title: 'Cost',
    type: 'report-section',
  },
  {
    component: <E3PeerGroup />,
    id: 36,
    groupId: 2,
    title: 'Peer Group Members',
    type: 'report-section',
  },
  {
    component: <E3Quality />,
    id: 37,
    groupId: 2,
    title: 'Quality',
    type: 'report-section',
  },
  {
    component: <E3Quantity />,
    id: 38,
    groupId: 2,
    title: 'Quantity',
    type: 'report-section',
  },
  {
    component: <NetworkPhysicalCharacteristicsBridges />,
    id: 39,
    groupId: 7,
    title: 'Bridges',
    type: 'report-section',
  },
  {
    component: <NetworkPhysicalCharacteristicsCycleways />,
    id: 40,
    groupId: 7,
    title: 'Cycleways',
    type: 'report-section',
  },
  {
    component: <NetworkPhysicalCharacteristicsRoads />,
    id: 41,
    groupId: 7,
    title: 'Roads',
    type: 'report-section',
  },
  {
    component: <RoadNetworkUseRoadUse />,
    id: 42,
    groupId: 8,
    title: 'Total Road Use',
    type: 'report-section',
  },
  {
    component: <RoadNetworkUseJourneyDistributionStreetCategory />,
    id: 43,
    groupId: 8,
    title: 'Journey Distribution - ONF Street Categories',
    type: 'report-section',
  },
  {
    component: <NetworkAvailabilityFreightAccessibilityDistributionOnrc />,
    id: 44,
    groupId: 9,
    title: 'Freight Access (ONRC)',
    type: 'report-section',
  },
  {
    component: <NetworkAvailabilityResilienceDistributionsStreetCategory />,
    id: 45,
    groupId: 9,
    title: 'Resilience Distributions (ONF Street Categories)',
    type: 'report-section',
  },
  {
    component: <TerritorialActivityEconomic />,
    id: 46,
    groupId: 11,
    title: 'Economic',
    type: 'report-section',
  },
  {
    component: <TerritorialActivityPopulation />,
    id: 47,
    groupId: 11,
    title: 'Population',
    type: 'report-section',
  },
  {
    component: <TemporaryTrafficManagementCostConfidence />,
    id: 48,
    groupId: 14,
    title: 'Cost Confidence',
    type: 'report-section',
  },
  {
    component: <TemporaryTrafficManagementCostPercentage />,
    id: 49,
    groupId: 14,
    title: 'Cost Percentage',
    type: 'report-section',
  },
  {
    component: <PublicTransportFleetSize />,
    id: 50,
    groupId: 10,
    title: 'Public Transport Fleet Size',
    type: 'report-section',
  },
  {
    component: <PublicTransportCommunityServiced />,
    id: 51,
    groupId: 10,
    title: 'Public Transport Community Serviced',
    type: 'report-section',
  },
  {
    component: <PublicTransportCommunities />,
    id: 52,
    groupId: 10,
    title: 'Public Transport Communities',
    type: 'report-section',
  },
  {
    component: <PublicTransportExpenditure />,
    id: 53,
    groupId: 10,
    title: 'Public Transport Expenditure',
    type: 'report-section',
  },
  {
    component: <PublicTransportTotalMobilityUse />,
    id: 54,
    groupId: 10,
    title: 'Total Mobility Use',
    type: 'report-section',
  },
  {
    component: <PublicTransportTotalMobilityCommunities />,
    id: 55,
    groupId: 10,
    title: 'Total Mobility Communities',
    type: 'report-section',
  },
  {
    component: <PublicTransportUse />,
    id: 56,
    groupId: 10,
    title: 'Public Transport Use',
    type: 'report-section',
  },
  {
    component: <RoadConditionRoadRoughness />,
    id: 57,
    groupId: 5,
    title: 'Road Roughness',
    type: 'report-section',
  },
  {
    component: <RoadMaintenanceDeliveryQuarterlyCosts />,
    id: 58,
    groupId: 4,
    title: 'Road Maintenance Delivery',
    type: 'report-section',
  },
  {
    component: <TransportProgrammeDeliveryWalkingCycling />,
    id: 59,
    groupId: 3,
    title: 'Walking and Cycling',
    type: 'report-section',
  },
  {
    component: <TransportProgrammeDeliveryManagement />,
    id: 60,
    groupId: 3,
    title: 'Management',
    type: 'report-section',
  },
  {
    component: <DataQualityWidget />,
    id: 61,
    groupId: 16,
    title: 'Data Quality KPI',
    type: 'dashboard-widget',
  },
  {
    component: <DataQualityExpectedStandard />,
    id: 62,
    groupId: 16,
    title: 'Data Quality at Expected Standard',
    type: 'report-section',
  },
  {
    component: <RoadNetworkUseRestrictedBridges />,
    id: 63,
    groupId: 8,
    title: 'Restricted Bridges',
    type: 'report-section',
  },
  {
    component: <RoadMaintenanceDeliveryPavementResurfacing />,
    id: 64,
    groupId: 4,
    title: 'Pavement Resurfacing',
    type: 'report-section',
  },
  {
    component: <RoadSafetyDsi />,
    id: 65,
    groupId: 6,
    title: 'Annual DSI & Crashes Involving DSI',
    type: 'report-section',
  },
  {
    component: <RoadSafetyCrashDistributionFreight />,
    id: 66,
    groupId: 6,
    title: 'DSI Distribution (ONF Freight)',
    type: 'report-section',
  },
  {
    component: <RoadSafetyCrashDistributionGeneralTraffic />,
    id: 67,
    groupId: 6,
    title: 'DSI Distribution (ONF General Traffic)',
    type: 'report-section',
  },
  {
    component: <RoadNetworkUseJourneyDistributionOnrc />,
    id: 68,
    groupId: 8,
    title: 'Journey Distribution - ONRC',
    type: 'report-section',
  },
  {
    component: <RoadNetworkUseJourneyDistributionFreight />,
    id: 69,
    groupId: 8,
    title: 'Journey Distribution - ONF Freight',
    type: 'report-section',
  },
  {
    component: <RoadNetworkUseJourneyDistributionGeneralTraffic />,
    id: 70,
    groupId: 8,
    title: 'Journey Distribution - ONF General Traffic',
    type: 'report-section',
  },
  {
    component: <TransportProgrammeDeliveryCostEfficiencyMaintenance />,
    id: 71,
    groupId: 3,
    title: 'Cost Efficiency - Maintenance, Operations and Renewals',
    type: 'report-section',
  },
  {
    component: <E3Trends />,
    id: 72,
    groupId: 2,
    title: 'Trends',
    type: 'report-section',
  },
  {
    component: <RoadSafetyCrashConditions />,
    id: 73,
    groupId: 6,
    title: 'Crash Conditions',
    type: 'report-section',
  },
  {
    component: <RoadSafetyCrashFactors />,
    id: 74,
    groupId: 6,
    title: 'Crash Factors',
    type: 'report-section',
  },
  {
    component: <RoadSafetyRoadAssessmentRating />,
    id: 75,
    groupId: 6,
    title: 'Road Assessment Rating',
    type: 'report-section',
  },
  {
    component: <RoadNetworkUseHeavyVehicleRoadUse />,
    id: 76,
    groupId: 8,
    title: 'Heavy Vehicle Road Use',
    type: 'report-section',
  },
  {
    component: <RoadConditionRutting />,
    id: 77,
    groupId: 5,
    title: 'CCDC Rutting',
    type: 'report-section',
  },
  {
    component: <RoadConditionTexture />,
    id: 78,
    groupId: 5,
    title: 'CCDC Texture',
    type: 'report-section',
  },
  {
    component: <NetworkAvailabilityFreightAccessibilityDistributionStreetCategory />,
    id: 79,
    groupId: 9,
    title: 'Freight Access (ONF Street Category)',
    type: 'report-section',
  },
  {
    component: <NetworkAvailabilityFreightAccessibilityDistributionFreight />,
    id: 80,
    groupId: 9,
    title: 'Freight Access (ONF Freight)',
    type: 'report-section',
  },
  {
    component: <NetworkAvailabilityFreightAccessibilityDistributionGeneralTraffic />,
    id: 81,
    groupId: 9,
    title: 'Freight Access (ONF General Traffic)',
    type: 'report-section',
  },
  {
    component: <NetworkPhysicalCharacteristicsAverageLife />,
    id: 82,
    groupId: 7,
    title: 'Average Life Achieved',
    type: 'report-section',
  },
  {
    component: <NetworkAvailabilityResilienceDistributionsOnrc />,
    id: 83,
    groupId: 9,
    title: 'Resilience Distributions (ONRC)',
    type: 'report-section',
  },
  {
    component: <NetworkAvailabilityResilienceDistributionsFreight />,
    id: 84,
    groupId: 9,
    title: 'Resilience Distributions (ONF Freight)',
    type: 'report-section',
  },
  {
    component: <NetworkAvailabilityResilienceDistributionsGeneralTraffic />,
    id: 85,
    groupId: 9,
    title: 'Resilience Distributions (ONF General Traffic)',
    type: 'report-section',
  },
];
